// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Ea8","question":"styles_question__2mD9t","inputVisibleButton":"styles_inputVisibleButton__1URPi","note":"styles_note__1farq"};